import { c as _c } from "react/compiler-runtime";
import type { PlanComparisonFeature } from '../plan-comparison';
import { FeatureUsageMarker } from './feature-usage-marker';
import { InfoTooltip } from '@/components/ui/info-tooltip';
export function PlanFeature(t0) {
  const $ = _c(16);
  const {
    feature
  } = t0;
  if (typeof feature === "string") {
    let t1;
    if ($[0] !== feature) {
      t1 = <span>{feature}</span>;
      $[0] = feature;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  const lastWordStart = feature.label.lastIndexOf(" ") + 1;
  let t1;
  if ($[2] !== feature.description || $[3] !== feature.tooltip) {
    t1 = [feature.description, feature.tooltip].filter(Boolean);
    $[2] = feature.description;
    $[3] = feature.tooltip;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const tooltip = t1.join(". ");
  let t2;
  if ($[5] !== feature.label || $[6] !== lastWordStart || $[7] !== tooltip) {
    t2 = tooltip ? <>{feature.label.slice(0, lastWordStart)}<span className="inline-flex items-center gap-1 whitespace-nowrap">{feature.label.slice(lastWordStart)}<InfoTooltip content={tooltip} /></span></> : feature.label;
    $[5] = feature.label;
    $[6] = lastWordStart;
    $[7] = tooltip;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <span>{t2}</span>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== feature.usageMarker) {
    t4 = feature.usageMarker && <FeatureUsageMarker marker={feature.usageMarker} />;
    $[11] = feature.usageMarker;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <span className="block"><span className="inline-flex flex-wrap items-center gap-x-2.5 gap-y-1">{t3}{t4}</span></span>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}